const config = {
  vuexStorageKeys: [
    'sessionToken'
  ],
  plugins: [
    'tk',
    'index',
    'device',
    'vuexStorage'
    // 'user',
    // 'routerAuth'
  ]
}
export default config
